<template>
  <div class="search">
    <input
      type="text"
      v-model="text"
      class="search-term"
      placeholder="Enter the name of location"
    />
    <button type="submit" class="search-button">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 pad-round"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </button>
  </div>
</template>
<script>
import { debounce } from "@/services/utils";

let searchInputChangeDebouncedCallback;
export default {
  data() {
    return {
      text: "",
    };
  },
  watch: {
    text(val) {
        if (!searchInputChangeDebouncedCallback) {
          searchInputChangeDebouncedCallback = debounce((val) => {
            this.$emit("search-input-changed", val);
          }, 500);
        }
        searchInputChangeDebouncedCallback(val);
    },
  },
};
</script>
<style scoped>
.search {
  width: 100%;
  position: relative;
  display: flex;
  margin-bottom: 40px;
  min-width: 300px;
  height: 40px;
}

.search-term {
  width: 100%;
  border: 3px solid #01e069;
  border-right: none;
  padding: 5px;
  height: 100%;
  border-radius: 5px 0 0 5px;
  outline: none;
  color: #333333;
  font-family: sans-serif, Verdana, Geneva, Tahoma;
}

.search-term::placeholder {
  letter-spacing: initial;
  font-size: 13.5px;
}

.search-button {
  width: 40px;
  border: 1px solid #01e069;
  background: #01e069;
  text-align: center;
  color: #fff;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  font-size: 20px;
}
.pad-round{
    margin: auto
}
</style>